import { useMutation, useQueryClient } from '@tanstack/react-query';

import type { RegenerateSkusRequest } from '@nucleus-commerce/api-client/admin';

import { productsApi } from '../api/products-api';

import { productKeys } from './product-keys';

/**
 * Rewrites the style number and the chosen variant SKUs from the rule. The product (root,
 * sequence, origin flags), its variants, preview and history all hang off the detail key, so
 * one invalidation refreshes them; lists show the root too.
 */
export function useRegenerateSkus(productId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (body: RegenerateSkusRequest) => productsApi.regenerateSkus(productId, body),
    meta: { successMessage: 'products:sku.toasts.regenerated' },
    onSuccess: () =>
      Promise.all([
        queryClient.invalidateQueries({ queryKey: productKeys.detail(productId) }),
        queryClient.invalidateQueries({ queryKey: productKeys.lists() }),
      ]),
  });
}
